import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import { SalesOrderDraftStatus } from 'src/types/application/SalesOrderDraftDTO';

interface Props {
  status: SalesOrderDraftStatus;
  /** When true, displays "Ready for Approval" badge instead of the normal status */
  isReadyForApproval?: boolean;
}

const statusConfig = {
  RECEIVED: { label: 'New', color: '#f9a825' },
  PENDING_REVIEW: { label: 'Pending Review', color: '#ed6c02' },
  APPROVED: { label: 'Approved', color: '#2e7d32' },
  REJECTED: { label: 'Rejected', color: '#d32f2f' },
  NEEDS_ATTENTION: { label: 'Needs Attention', color: '#ed6c02' },
  WAITING_ON_CUSTOMER: { label: 'Waiting on Customer', color: '#1976d2' },
};

const readyForApprovalConfig = {
  label: 'Ready for Approval',
  color: '#2e7d32',
};

export function SalesOrderDraftStatusBadge({
  status,
  isReadyForApproval,
}: Props) {
  const config = isReadyForApproval
    ? readyForApprovalConfig
    : statusConfig[status as keyof typeof statusConfig] || {
        label: status || 'Unknown',
        color: '#757575',
      };

  return (
    <MDBox
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: 0.5,
        borderRadius: '4px',
        backgroundColor: `${config.color}15`,
        border: `1px solid ${config.color}40`,
      }}
    >
      <MDTypography
        variant="caption"
        sx={{
          color: config.color,
          fontWeight: 500,
          fontSize: '0.75rem',
        }}
      >
        {config.label}
      </MDTypography>
    </MDBox>
  );
}
